import React from 'react';
import { IonText } from '@ionic/react';
import './NoData.css';

const NoData: React.FC = () => {
  return (
    <IonText>
      <img
        src="assets/empty.png"
        alt="empty box"
        className="centered"
        style={{
          width: 250,
        }}
      />
    </IonText>
  );
};

export default NoData;
